import { config } from "./baseUrl";
import { getEnvArea } from "./utils";

let proxyBaseUrl = config[getEnvArea()];

// 如果没有获取到环境变量，默认使用 test_cn
if (!proxyBaseUrl) {
  proxyBaseUrl = config.test_cn;
}

// 代理地址必须包含协议
if (proxyBaseUrl && proxyBaseUrl.startsWith("//")) {
  proxyBaseUrl = `http:${proxyBaseUrl}`;
}

/**
 * 代理配置
 */
const proxy = {
  "/api/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/mtsV2/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/stub/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/system/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/auth/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/employee/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/loginLog/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
};

export default proxy;
